export default __webpack_public_path__ + "static/media/img_1@2x.e3946cba.png";